import { useRouter } from 'next/router';
import { ReactNode, useContext, useState, createContext } from 'react';
import { useQuery } from 'react-query';
import { api } from 'services/api';
import ICustomAxiosRequestConfig from 'services/custom/ICustomAxiosRequestConfig';

export const FIFTEEN_MINUTES_STALE = 1000 * 60 * 15;

export interface IOccasion {
  id: string;
  name: string;
  slug: string;
  image: string;
}

type GetLinesResponse = {
  status: number;
  data: IOccasion[];
};

type IOccasionContext = {
  handleClickInOccasion: (occasion: IOccasion) => void;
  setOccasionName: (occasionName: string) => void;
  occasionName: string;
};

export const getOccasions = async (serverSide?: {
  serverSide: boolean;
}): Promise<GetLinesResponse> => {
  const { status, data } = await api.get(
    '/restaurant/v1/occasions?pagination=0',
    {
      serverSide,
    } as ICustomAxiosRequestConfig
  );

  return {
    status,
    data: data.data,
  };
};

export const useOccasions = () => {
  return useQuery('occasions', () => getOccasions(), {
    staleTime: FIFTEEN_MINUTES_STALE,
  });
};

export const OccasionContext = createContext({} as IOccasionContext);

const OccasionProvider = ({ children }: { children: ReactNode }) => {
  const [occasionName, setOccasionName] = useState('');
  const router = useRouter();

  const handleClickInOccasion = ({ id, name }: IOccasion) => {
    setOccasionName(name);
    router.push(`/restaurants?occasion=${id}`);
  };

  return (
    <OccasionContext.Provider
      value={{
        setOccasionName,
        handleClickInOccasion,
        occasionName,
      }}
    >
      {children}
    </OccasionContext.Provider>
  );
};

const useOccasion = () => useContext(OccasionContext);

export { OccasionProvider, useOccasion };
